import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useMemo } from 'react';
import { ENDPOINTS } from './../../endpoints';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import useServices from '../../hooks/useServices';

var ServiceEmployers = /*#__PURE__*/function (_Service) {
  _inherits(ServiceEmployers, _Service);

  var _super = _createSuper(ServiceEmployers);

  function ServiceEmployers() {
    var _this;

    _classCallCheck(this, ServiceEmployers);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getEmployerContacts", function (organizationId) {
      return _this.axiosInstance.get(ENDPOINTS.employers.employerContacts, {
        params: {
          organization_id: organizationId
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "get_ad_performance_statistics", function (jobPositionId) {
      return _this.axiosInstance.get(ENDPOINTS.employers.adPerformanceStatistics, {
        params: {
          job_position_id: jobPositionId
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "is_subscription_feedbacks_submitted", function (employerId) {
      return _this.axiosInstance.get(ENDPOINTS.employers.isSubscriptionFeedbacksSubmitted, {
        params: {
          employer_id: employerId
        }
      });
    });

    return _this;
  }

  _createClass(ServiceEmployers, [{
    key: "fetchEmployers",
    value: function fetchEmployers(_ref) {
      var limit = _ref.limit,
          offset = _ref.offset,
          order_by = _ref.order_by,
          filters = _ref.filters;
      return this.axiosInstance.get(ENDPOINTS.employers.root, {
        params: _objectSpread({
          limit: limit,
          offset: offset,
          order_by: order_by
        }, filters)
      });
    }
  }, {
    key: "showEmployer",
    value: function showEmployer(employerId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.employers.root, "/").concat(employerId));
    }
  }, {
    key: "searchCompanies",
    value: function searchCompanies(_ref2) {
      var searchText = _ref2.searchText,
          countryCode = _ref2.countryCode;
      return this.axiosInstance.get(ENDPOINTS.employers.searchCompanies, {
        params: {
          search_text: searchText,
          country_code: countryCode
        }
      });
    }
  }, {
    key: "sendSubscriptionEmail",
    value: function sendSubscriptionEmail(_ref3) {
      var employerId = _ref3.employerId,
          paymentLink = _ref3.paymentLink;
      return this.axiosInstance.post(ENDPOINTS.employers.subscriptionEmail, {
        employer_id: employerId,
        payment_link: paymentLink
      });
    }
  }, {
    key: "uploadPicture",
    value: function uploadPicture(_ref4) {
      var employerId = _ref4.employerId,
          file = _ref4.file;
      var formData = new FormData();
      formData.append('user_id', employerId);
      formData.append('picture', file);
      return this.axiosInstance.post(ENDPOINTS.employers.picture, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "deletePicture",
    value: function deletePicture(employerId) {
      return this.axiosInstance["delete"](ENDPOINTS.employers.picture, {
        data: {
          user_id: employerId
        }
      });
    }
  }, {
    key: "fetchInvoices",
    value: function fetchInvoices(_ref5) {
      var limit = _ref5.limit,
          offset = _ref5.offset,
          employerId = _ref5.employerId,
          organizationId = _ref5.organizationId,
          onlyPaid = _ref5.onlyPaid,
          csmId = _ref5.csmId,
          cancelled = _ref5.cancelled;
      return this.axiosInstance.get(ENDPOINTS.employers.invoices, {
        params: {
          employer_id: employerId,
          csm_id: csmId,
          limit: limit,
          offset: offset,
          'paid?': onlyPaid,
          'cancelled?': cancelled,
          organization_id: organizationId
        }
      });
    }
  }, {
    key: "createInvoice",
    value: function createInvoice(_ref6) {
      var invoice = _ref6.invoice;
      return this.axiosInstance.post(ENDPOINTS.employers.invoices, _objectSpread({}, invoice));
    }
  }, {
    key: "updateInvoice",
    value: function updateInvoice(_ref7) {
      var invoiceId = _ref7.invoiceId,
          params = _ref7.params;
      return this.axiosInstance.put("".concat(ENDPOINTS.employers.invoices, "/").concat(invoiceId), _objectSpread({}, params));
    }
  }, {
    key: "fetchInvoicePdf",
    value: function fetchInvoicePdf(_ref8) {
      var invoiceId = _ref8.invoiceId;
      return this.axiosInstance.get(ENDPOINTS.employers.invoicePdf, {
        responseType: 'blob',
        params: {
          invoice_id: invoiceId
        }
      });
    }
  }, {
    key: "fetchNotes",
    value: function fetchNotes(_ref9) {
      var entityCategory = _ref9.entityCategory,
          entityId = _ref9.entityId,
          noteCategory = _ref9.noteCategory,
          organizationId = _ref9.organizationId;
      return this.axiosInstance.get(ENDPOINTS.employers.notes, {
        params: {
          id: entityId,
          entity_category: entityCategory,
          category: noteCategory,
          organization_id: organizationId
        }
      });
    }
  }, {
    key: "insertNote",
    value: function insertNote(_ref10) {
      var entityCategory = _ref10.entityCategory,
          entityId = _ref10.entityId,
          note = _ref10.note,
          category = _ref10.category,
          jobPositionId = _ref10.jobPositionId,
          workerId = _ref10.workerId,
          organizationId = _ref10.organizationId,
          jobApplicationId = _ref10.jobApplicationId;
      return this.axiosInstance.post(getEndpoint(entityCategory), _objectSpread({
        note: note,
        category: category,
        job_position_id: jobPositionId,
        worker_id: workerId,
        organization_id: organizationId,
        job_application_id: jobApplicationId
      }, entityId ? formatEntityId(entityCategory, entityId) : {}));
    }
  }, {
    key: "updateNote",
    value: function updateNote(_ref11) {
      var note = _ref11.note,
          noteId = _ref11.noteId;
      return this.axiosInstance.put("".concat(ENDPOINTS.employers.notes, "/").concat(noteId), {
        note: note
      });
    }
  }, {
    key: "removeNote",
    value: function removeNote(noteId) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.employers.notes, "/").concat(noteId));
    }
  }, {
    key: "indexSubscriptions",
    value: function indexSubscriptions(employerId) {
      return this.axiosInstance.get(ENDPOINTS.employers.subscription, {
        params: {
          employer_id: employerId
        }
      });
    }
  }, {
    key: "createSubscriptionSession",
    value: function createSubscriptionSession(_ref12) {
      var duration = _ref12.duration,
          pricingType = _ref12.pricingType,
          slots = _ref12.slots,
          companyId = _ref12.companyId;
      return this.axiosInstance.post(ENDPOINTS.employers.subscriptionSession, {
        company_id: companyId,
        duration: duration,
        pricing_type: pricingType,
        slots: slots
      });
    }
  }, {
    key: "indexPaymentMethods",
    value: function indexPaymentMethods(employerId) {
      return this.axiosInstance.get(ENDPOINTS.employers.paymentMethod, {
        params: {
          employer_id: employerId
        }
      });
    }
  }, {
    key: "updateAssignation",
    value: function updateAssignation(_ref13) {
      var employerId = _ref13.employerId,
          assignedTo = _ref13.assignedTo;
      return this.axiosInstance.post(ENDPOINTS.employers.assignCustomerSuccessManager, {
        employer_id: employerId,
        assigned_to: assignedTo
      });
    }
  }, {
    key: "updateEmployer",
    value: function updateEmployer(_ref14) {
      var employerId = _ref14.employerId,
          params = _ref14.params;
      return this.axiosInstance.put("".concat(ENDPOINTS.employers.root, "/").concat(employerId), _objectSpread({}, params || {}));
    }
  }, {
    key: "createEmployerContact",
    value: function createEmployerContact(employerContact) {
      return this.axiosInstance.post(ENDPOINTS.employers.employerContact, _objectSpread({}, employerContact || {}));
    }
  }, {
    key: "updateEmployerContact",
    value: function updateEmployerContact(_ref15) {
      var employerContactId = _ref15.employerContactId,
          params = _ref15.params;
      return this.axiosInstance.patch("".concat(ENDPOINTS.employers.employerContact, "/").concat(employerContactId), _objectSpread({}, params || {}));
    }
  }, {
    key: "redirectStripeCustomerPortal",
    value: function redirectStripeCustomerPortal() {
      return this.axiosInstance.get(ENDPOINTS.employers.stripeCustomerPortal);
    }
  }, {
    key: "createCheckoutSession",
    value: function createCheckoutSession(invoiceId) {
      return this.axiosInstance.get(ENDPOINTS.employers.createCheckoutSession, {
        params: {
          invoice_id: invoiceId
        }
      });
    }
  }, {
    key: "getAccessLink",
    value: function getAccessLink(employerId) {
      return this.axiosInstance.get(ENDPOINTS.employers.accessLink, {
        params: {
          employer_id: employerId
        }
      });
    }
  }, {
    key: "createEmployerSubscriptionFeedback",
    value: function createEmployerSubscriptionFeedback(params) {
      return this.axiosInstance.post(ENDPOINTS.employers.subscriptionFeedback, _objectSpread({}, params));
    }
  }, {
    key: "fetchSubscriptionFeedbackByOrganization",
    value: function fetchSubscriptionFeedbackByOrganization(params) {
      return this.axiosInstance.get(ENDPOINTS.employers.fetchEmployerSubscriptionFeedbackByOrganization, {
        params: params
      });
    }
  }, {
    key: "cancelStripeSubscription",
    value: function cancelStripeSubscription(_ref16) {
      var stripeSubscriptionId = _ref16.stripeSubscriptionId;
      return this.axiosInstance.post(ENDPOINTS.employers.cancelStripeSubscription, {
        stripe_subscription_id: stripeSubscriptionId
      });
    }
  }]);

  return ServiceEmployers;
}(Service);

var formatEntityId = function formatEntityId(category, entityId) {
  return _defineProperty({}, "".concat(category, "_id"), entityId);
};

var getEndpoint = function getEndpoint(entityCategory) {
  switch (entityCategory) {
    case 'worker':
      return ENDPOINTS.workers.notes;

    default:
      return ENDPOINTS.employers.notes;
  }
};

export function useEmployersService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceEmployers(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export var createEmployerService = function createEmployerService(_ref18) {
  var baseUrl = _ref18.baseUrl,
      jwt = _ref18.jwt;
  return new ServiceEmployers(dynamicAxios(baseUrl, jwt));
};
export default useEmployersService;
export * from './types';